export default {
  full_menu: 'Menu Completo',
  free: 'GRÁTIS',
};
